import { CommonModule } from '@angular/common';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-card',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="card" [ngClass]="{'lessPaddingY':lessPaddingY,'lessPaddingX':lessPaddingX ,'background-none':background_none ,'border_radius_none':border_radius_none}">
      <h2 class="headline-medium" [ngClass]="{'font-cart':lessPaddingX}">
        {{ title }} <span class="body-small">{{ helperText }}</span>
      </h2>
      <div *ngIf="divider" class="divider"></div>
      <ng-content></ng-content>
    </div>
  `,
  styles: [
    `
      .card {
        width:100%;
        padding: 2rem;
        border-radius: 24px;
        background: var(--white);
      }

      .divider {
        margin-left: -1rem;
        width: calc(100% - -2rem);
        display: flex;
        border-bottom: 1px solid var(--gray200);
      }

      .lessPaddingY {
        padding-top:0.5rem !important;
        padding-bottom:0.5rem !important;
      }
      .lessPaddingX {
        padding-right:1rem !important;
        padding-left:1rem !important;
      }
      .background-none{
        background: transparent !important;
      }
      .border_radius_none{
        border-radius:0px;
      }
      .font-cart{
        font-family: Lufga;
        font-size: 18px;
        font-weight: 500;
        line-height: 24px;
        text-align: left;
        color:#141414;
      }

    `,
  ],
})
export class CardComponent implements OnInit
{
  @Input() title: string;
  @Input() helperText: string;
  @Input() divider = false;
  @Input() lessPaddingY = false;
  @Input() lessPaddingX = false;
  @Input() background_none = false;
  @Input() border_radius_none = false;
  constructor() { }

  ngOnInit() { }
}
